import withStyles from '@material-ui/styles/withStyles';
import { Grid, Typography } from '@material-ui/core';
import startCase from 'lodash/startCase';

const DropdownOption = ({ element, classes }) => {
  const imageBase64 = element.get('imageDataBase64');
  const name = element.get('name');
  return (
    <Grid className={classes.container}>
      <img
        src={`data:image/png;base64,${imageBase64}`}
        alt={name}
        className={classes.previewImage}
      />
      <Typography type="body-2">{startCase(name)}</Typography>
    </Grid>
  );
};

const styles = (theme) => ({
  container: {
    display: 'flex',
    alignItems: 'center',
  },
  previewImage: {
    width: theme.spacing(4),
    height: theme.spacing(4),
    marginRight: theme.spacing(1),
  },
});

export default withStyles(styles)(DropdownOption);
